import type { Campaign } from '@feathr/blackbox';
import { EIntegrationTypes } from '@feathr/blackbox';

interface IUseCampaignChannelVisibilityReturn {
  showDisplay: boolean;
  showMeta: boolean;
}

/**
 * Derives channel visibility for the reachability breakdown based on
 * the campaign's integrations.
 *
 * @param campaign - The campaign to check integrations for.
 * @returns showDisplay and showMeta booleans for TargetAudienceOverview.
 */
function useCampaignChannelVisibility(campaign: Campaign): IUseCampaignChannelVisibilityReturn {
  const integrations = (campaign.get('integrations') as EIntegrationTypes[] | undefined) ?? [];
  const hasMetaIntegration = integrations.includes(EIntegrationTypes.Meta);
  const hasDisplayIntegration = integrations.includes(EIntegrationTypes.Tradedesk);

  return {
    showDisplay: hasDisplayIntegration,
    showMeta: hasMetaIntegration,
  };
}

export default useCampaignChannelVisibility;
